export const paramsValue = {
  TRUE: "true",
  FALSE: "false"
};
